import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { buildWhatsappURL } from "@/data/site";
import { MOUNTAIN_IMAGE } from "@/data/site";

export default function FinalCTA({ onBook }) {
  return (
    <section data-testid="final-cta" className="relative py-24 md:py-32 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img src={MOUNTAIN_IMAGE} alt="Gangtok sunset" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/85 via-[#0a0a0a]/70 to-[#0a0a0a]" />
        <div className="absolute inset-0 grain" />
      </div>
      <div className="relative max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="text-xs uppercase tracking-[0.3em] text-[#f5f0ea]">
            Last call
          </div>
          <h2 className="mt-4 font-display text-5xl sm:text-7xl lg:text-8xl font-bold tracking-tighter text-white">
            Ready to find <br />
            your <span className="text-[#A7D38B] italic">tribe?</span>
          </h2>
          <p className="mt-6 text-neutral-300 max-w-xl mx-auto">
            16 rooms. Endless nights. One unforgettable Gangtok story waiting
            for your name on it.
          </p>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <button
              onClick={onBook}
              data-testid="final-book-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#62794d] text-[#f5f0ea] px-7 py-4 font-semibold text-sm hover:bg-[#7a9261] active:scale-[0.98] transition shadow-[0_10px_40px_rgba(98,121,77,0.4)]"
            >
              Book Now <ArrowUpRight size={18} />
            </button>
            <a
              href={buildWhatsappURL({ message: "Add me to the community!" })}
              target="_blank"
              rel="noreferrer"
              data-testid="final-community-btn"
              className="inline-flex items-center gap-2 rounded-full glass px-7 py-4 font-semibold text-sm hover:bg-white/10 transition text-white"
            >
              <MessageCircle size={18} /> Join Community
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
